import axios from 'axios'
import {
  router
} from '@/router';
import {
  getToken,
  removeToken,
  getAppId
} from '@/utils/auth'
// import { Notify, Toast } from 'vant';
import {
  Notify,
  Toast
} from 'vant';
let url;
if (process.env.NODE_ENV === "development") {
  url = process.env.VUE_APP_BASE_API
} else {
  url = '/'
}
// create an axios instance
const service = axios.create({
  baseURL: url, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000 // request timeout
})

// request interceptor   
service.interceptors.request.use(
  config => {
    let token=localStorage.getItem('userToken');
    if (token) {
      config.headers['token'] = token;
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data;
    let getUrl = response.config.url;
    if (res.errcode != 0) {
     if (res.errcode == 4001) {
        router.push({
          path: "login"
        })
      }
      if (res.errcode == 4000) {
        if(getUrl=='/api/goods/trialList'){
          router.push({
            path: "personal"
          })
        }
      }
      Toast({
        message: res.msg || '错误',
        duration: 3 * 1000,
      });
      return Promise.reject(res.msg || 'error')
    } else {
      return res.res
    }
  },
  error => {
    Notify({
      message: error.message || '错误',
      duration: 3 * 1000,
    });
    return Promise.reject(error)
  }
)
export default service